import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function CountdownTimer({
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  if (isExpired) {
    return <div className={`font-bold text-brand-red ${className}`} data-id="element-58">
        OFERTA EXPIRADA
      </div>;
  }
  const sizeClasses = {
    sm: 'text-sm px-2 py-1',
    md: 'text-xl px-3 py-2',
    lg: 'text-3xl px-4 py-3'
  };
  return <div className={`flex items-center justify-center space-x-2 font-mono font-bold ${className}`} data-id="element-59">
      <div className={`bg-brand-dark border border-brand-red/30 rounded-lg text-white ${sizeClasses[size]}`} data-id="element-60">
        00
      </div>
      <span className="text-brand-red font-bold" data-id="element-61">:</span>
      <div className={`bg-brand-dark border border-brand-red/30 rounded-lg text-white ${sizeClasses[size]}`} data-id="element-62">
        {minutes}
      </div>
      <span className="text-brand-red font-bold" data-id="element-63">:</span>
      <div className={`bg-brand-dark border border-brand-red/30 rounded-lg text-white ${sizeClasses[size]}`} data-id="element-64">
        {seconds}
      </div>
    </div>;
}